// removed by extract-text-webpack-plugin
module.exports = {"root":"TabPanel__root___1N5cV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTabs/TabPanel/TabPanel.css
// module id = 967
// module chunks = 0